import app from 'flarum/forum/app';
export default function loadCommunityUsers() {
  // Каталог получает только публичный DTO и не запрашивает приватные атрибуты стандартного user API.
  return app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/devconnect/users`
  });
}
flarum.reg.add('devconnect-community', 'forum/service/userDirectoryApi', loadCommunityUsers);